import SettingPage from '@/pages/settings/CMSettingPage.vue'
import ApplicationSettingPage from '@/pages/settings/CMApplicationSettingsPage.vue'
import RemindSettingPage from '@/pages/settings/CMRemindSettingPage.vue'
import EditRemindSetting from '@/pages/settings/CMEditRemindSetting.vue'
import AddRemindSetting from '@/pages/settings/CMAddRemindSetting.vue'
import RemindSettingContactList from '@/pages/settings/CMRemindSettingContactList.vue'
import DirectDebitSettingsPage from '@/pages/settings/CMDirectDebitSettingsPage.vue'
import DirectPaymentsSettingsPage from '@/pages/settings/CMDirectPaymentsSettingsPage.vue'
import EcheancierListe from '@/pages/reglesEcheancier/EcheancierListe.vue'
import SettingsEcheancier from '@/pages/reglesEcheancier/SettingsEcheancierRegles.vue'
import PagePaymentLMSG from '@/pages/requests/creationPages/PagePaymentLMSG.vue'

export default [
  {
    path: '/settings/',
    component: SettingPage
  },
  {
    path: '/settings/remind/',
    component: RemindSettingPage
  },
  {
    path: '/settings/application/',
    component: ApplicationSettingPage
  },
  {
    path: '/settings/directDebit/',
    component: DirectDebitSettingsPage
  },
  {
    path: '/settings/directPayments/',
    component: DirectPaymentsSettingsPage
  },
  {
    path: '/settings/remind/edit/',
    component: EditRemindSetting
  },
  {
    path: '/settings/remind/add/',
    component: AddRemindSetting
  },
  {
    path: '/settings/remind/contactList/:contactListType/',
    component: RemindSettingContactList
  },
  {
    path: '/settings/echeancier',
    component: EcheancierListe
  },
  {
    path: '/settings/echeancier/edit/:id',
    component: SettingsEcheancier
  },
  {
    path: '/settings/echeancier/add',
    component: SettingsEcheancier
  },
  {
    path: '/lmsg/',
    component: PagePaymentLMSG
  }
]
